import React from "react";

import { StudentProfileEdit } from "../StudentProfileEdit";

export const StudentProfile: React.FC = () => {
  return <StudentProfileEdit viewonly={true} canDelete={true} />;
};
